import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";
import firebase, { firebaseNotification } from "./utils/firebaseConfig";
import {
  storeUserDetails,
  clearUserDetails
} from "./store/actionCreators/userDetails";
import loadable from "react-loadable";
import fetchIntercept from "fetch-intercept";
import {
  WELCOME_PAGE_URL,
  AUTH_PAGE_URL,
  DASHBOARD_PAGE_URL,
  SETTING_PAGE_URL,
  RESTAURANT_PAGE_URL,
  CHECKOUT_PAGE_URL,
  CAFE_PASS_URL,
  PRE_BOOK_URL
} from "./utils/Route";

import "./App.css";

import Loading from "./components/Utils/Loading";
import Snackbar from "./components/Utils/Notification";
import ErrorBoundary from "./components/Utils/ErrorBoundary";
import AutoUpdate from "./components/Utils/AutoUpdate";

import postJSON from "./utils/PostJSON";
import {
  EXCLUDE_URLS,
  BASE_URL,
  CHECK_AUTHENTICATION,
  LOGOUT,
  UPDATE_PUSH_ID,
  FIREBASE_STATIC_DATA,
  GET_FOOD_COURT_SETTINGS,
  SWAGGER_EXCLUDE_URL
} from "./utils/Urls";
import {
  NOTIFICATION_PERMISSION,
  SESSION_TIMINGS,
  GENERAL_ERROR_MSG
} from "./utils/Constants";
import AddToHomeScreenWrapper from "./components/Utils/AddToHomeScreenWrapper";
import { setFirebaseStaticData } from "./store/actionCreators/setFirebaseStaticData";
import { clearNotificationPermission } from "./store/actionCreators/firebaseDetails";
import { setErrorMessage } from "./store/actionCreators/errorMessage";
import storeFoodCourtSettings from "./store/actionCreators/foodCourtSettings";
import setFoodCourt from "./store/actionCreators/currentFoodCourt";
// import ConfirmBox from "./components/Utils/ConfirmBox";
import { GET_USER_TOKEN } from "./utils/CommonFunctions";
import { setSessionsData } from "./store/actionCreators/sesssionsData";

import CafePass from "./pages/CafePass";

const Home = loadable({
  loader: () => import("./pages/Home"),
  loading: () => <Loading />
});

const SignupSignin = loadable({
  loader: () => import("./pages/SignupSignin"),
  loading: () => <Loading />
});
const Dashboard = loadable({
  loader: () => import("./pages/Dashboard"),
  loading: () => <Loading />
});
const Restaurant = loadable({
  loader: () => import("./pages/Restaurant"),
  loading: () => <Loading />
});

const Checkout = loadable({
  loader: () => import("./pages/Checkout"),
  loading: () => <Loading />
});
const Settings = loadable({
  loader: () => import("./pages/Settings"),
  loading: () => <Loading />
});

const OrderSuccessModal = loadable({
  loader: () => import("./components/Utils/OrderSuccessModal"),
  loading: () => <Loading />
});

const NotificationHandler = loadable({
  loader: () => import("./components/Utils/NotificationHandler"),
  loading: () => <Loading />
});

const ConfirmBox = loadable({
  loader: () => import("./components/Utils/ConfirmBox"),
  loading: () => <Loading />
});

const TCDialog = loadable({
  loader: () => import("./components/Utils/TCDialog"),
  loading: () => <Loading />
});

const AlertPopup = loadable({
  loader: () => import("./components/Utils/AlertPopup"),
  loading: () => <Loading />
});

class App extends Component {
  constructor(props) {
    super(props);

    this.registerGlobalInterceptor();

    let foodCourtId = localStorage.getItem("currentFoodCourt") || "{}";
    foodCourtId = JSON.parse(foodCourtId).value;
    this.handleAuthAPI(foodCourtId);
    if (foodCourtId === undefined) {
      props.history.replace("/");
    }

    this.state = {
      loggedIn: null,
      userVerified: false,
      // loading: foodCourtId ? true : false,
      loading: true,
      showSuccessCard: false,
      deferredPrompt: null,
      tokenRetryInterval: 4000,
      notificationDetails: {},
      askNotificationConfirmation: false,
      successModaltimeout: 30000,
      showFoodcourtListing: false,
      hideAlertBtn: false
    };
  }

  registerGlobalInterceptor = () => {
    this.unregister = fetchIntercept.register({
      request: function (url, config) {
        // Modify the url or config here
        return [url, config];
      },

      requestError: function (error) {
        // Called when an error occured during another 'request' interceptor call
        return Promise.reject(error);
      },

      response: async response => {
        const { pathname } = this.props.location;

        if (pathname !== WELCOME_PAGE_URL && pathname !== AUTH_PAGE_URL) {
          if (EXCLUDE_URLS.includes(response.url)) {
            return response;
          }

          // to handle authentication in dev this below condition is required
          if (process.env.NODE_ENV === "production") {
            if (response.url.includes(SWAGGER_EXCLUDE_URL)) {
              if (response.status > 400) {
                this.resetApp();
              } else {
                return response;
              }
            }
          }

          let newData = await response.clone();
          newData = await newData.json();
          if (newData.result && newData.result !== "success") {
            // If we did not add below check, for other failures also it will logout
            if (
              (newData.extras.hasOwnProperty("auth") && !newData.extras.auth) ||
              newData.extras === "invalid cookie"
            ) {
              this.resetApp();
            }
          } else {
            // if (newData.extras.hasOwnProperty("auth") && !newData.extras.auth) {
            // this.resetApp();
            // }
          }
        }

        return response;
      },

      responseError: function (error) {
        // Handle an fetch error
        return Promise.reject(error);
      }
    });
  };

  showPopupHandler = () => {
    if (this.isFCMSupported())
      this.setState({ askNotificationConfirmation: true });
  };

  cancelPopupHandler = () => {
    this.setState({ askNotificationConfirmation: false });
  };

  checkToAskNotification = () => {
    if (!("serviceWorker" in navigator && this.isFCMSupported())) return;
    const permission = Notification.permission;
    // if (permission == "granted") this.getPushNotificationPermission();
    if (permission == "default") {
      setTimeout(this.showPopupHandler, 3000);
    }
  };

  getPushNotificationPermission = () => {
    this.cancelPopupHandler();
    firebaseNotification
      .requestPermission()
      .then(() => {
        console.log("Have Permission");
        this.getTokenFromFCM();
        return;
      })
      .catch(err => {
        console.log("Error Occurred", err);
      });
  };

  getTokenFromFCM = () => {
    if (!this.isFCMSupported()) return;
    firebaseNotification
      .getToken()
      .then(token => {
        console.log(token);
        if (token) this.sendBrowserTokenToServer(token);
      })
      .catch(err => {
        console.log("Error Occurred in getting FCM token", err);
        this.retryTokenFetching();
      });
  };

  retryTokenFetching = () => {
    const { tokenRetryInterval } = this.state;
    console.log(`retring after ${tokenRetryInterval / 1000} seconds`);
    setTimeout(this.getTokenFromFCM, tokenRetryInterval);
    this.setState({ tokenRetryInterval: tokenRetryInterval * 2 });
  };

  sendBrowserTokenToServer = token => {
    const params = {
      sender: "web",
      useros: "pwa",
      pushid: token
    };
    postJSON(
      BASE_URL + UPDATE_PUSH_ID,
      params,
      response => {
        console.log("sendBrowserTokenToServer() token was saved", response);
        this.setState({ tokenRetryInterval: 2000 });
        // this.subscribeToFCMEvent();
      },
      response => {
        console.log("sendBrowserTokenToServer() token was not saved", response);
        this.retryTokenFetching();
      }
    );
  };

  isFCMSupported = () => {
    if (firebase.messaging.isSupported()) return true;
    else {
      console.log("FCM is not supported in this browser");
      return false;
    }
  };

  closeNotitificationDialog = () => {
    this.setState({ notificationDetails: {} });
  };

  HandleNotificationClick = notification => {
    console.log("TCL: App -> notification", notification);
    const { url, click_action } = notification;
    if (url) {
      const notificationDetails = {
        show: true,
        ...notification
      };
      this.setState({ notificationDetails });
    } else {
      this.props.history.push(click_action);
    }
  };

  subscribeToFCMEvent = () => {
    firebaseNotification.onMessage(payload => {
      console.log("on Message", payload);
      const { notification, data } = payload;
      const url = (data || {})["gcm.notification.html_file_path"];
      const notificationTitle = notification.title || "Order Status Updated";
      const notificationOptions = {
        body: notification.body || "click to go to order history",
        icon: notification.icon || "/foodbook-pwa/FBLogo-144x144.png",
        url
      };
      notification.url = url;

      var myNotification = new Notification(
        notificationTitle,
        notificationOptions
      );

      myNotification.onclick = () => {
        this.HandleNotificationClick(notification);
        console.log(
          "TCL: App -> myNotification.onclick -> this.props",
          this.props
        );
      };
    });
  };

  initialiseFCM = () => {
    if ("serviceWorker" in navigator && this.isFCMSupported()) {
      navigator.serviceWorker.ready.then(swReg => {
        firebaseNotification.useServiceWorker(swReg);
        if ("Notification" in window && Notification.permission === "granted") {
          this.getTokenFromFCM();
        }
        this.subscribeToFCMEvent();
      });
    }
  };

  HandlingSafariPaymentRedirection = () => {
    window.onpageshow = function (event) {
      console.log(
        "TCL: App -> window.onpageshow -> event.persisted",
        event.persisted
      );
      var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
      var iOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      if (event.persisted && (iOS || isSafari)) {
        window.location.reload();
        console.log("event.persisted called :", event.persisted);
      }
    };
  };

  SWMessageListerner = () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", event => {
        this.HandleNotificationClick(event.data);
      });
    }
  };

  fetchFirebaseStaticData = () => {
    fetch(FIREBASE_STATIC_DATA, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.props.setFirebaseStaticData(response);
      });
  };

  componentDidMount = () => {
    this.HandlingSafariPaymentRedirection();
    this.initialiseFCM();
    this.SWMessageListerner();
    this.fetchFirebaseStaticData();
    this.getSucessModalTimeoutFromFirebase();
    this.props.setSessionsData(SESSION_TIMINGS);
    if (this.props.isPreOrder) {
      const { currentFoodCourtDetails } = this.props;
      const preOrderingDetails =
        (((currentFoodCourtDetails || {}).extras || {}).extras || {})
          .preordering || {};
      const prebookingSlots = preOrderingDetails["chooseslots"] || [];
      if (prebookingSlots.length > 0) {
        const newSessionsObject = prebookingSlots.reduce((acc, cur) => {
          let currentValue = {
            [cur["txt"]]: cur["val"]
          };

          if (acc) {
            return { ...acc, ...currentValue };
          }

          return currentValue;
        }, {});
        this.props.setSessionsData(newSessionsObject);
      }
    }
  };

  closeFoodcourtListing = () => {
    this.setState({ showFoodcourtListing: false });
  };

  checkAuth = (extras, customlogin) => {
    const {
      auth,
      message,
      isverified,
      details,
      foodcourtDetails,
      showFoodcourtListing
    } = extras;
    if (foodcourtDetails) {
      // For Nvidia- token based login
      this.props.setFoodCourt(foodcourtDetails);
      localStorage.setItem(
        "currentFoodCourt",
        JSON.stringify(foodcourtDetails)
      );
    }

    if (!auth && customlogin) {
      this.setState({ hideAlertBtn: true });
      this.props.setAlertPopup(message);
    }

    this.setState(
      {
        loggedIn: auth || false,
        userVerified: isverified || false,
        showFoodcourtListing
      },
      this.redirect
    );
    if (details) {
      this.props.storeUserDetails(details);
    }
  };

  handleAuthAPI = foodCourtId => {
    let params = { foodcourtid: foodCourtId };
    const { token, location, mobileno, city } = GET_USER_TOKEN();
    let customlogin = false;
    if (token) {
      params.token = token;
      params.customlogin = true;
      params.location = location;
      params.mobileno = mobileno;
      params.city = city;
      customlogin = true;
    }

    setTimeout(() => {
      this.setState({ customlogin });
    }, 1000);

    postJSON(
      BASE_URL + CHECK_AUTHENTICATION,
      params,
      response => {
        this.checkAuth(response.extras, customlogin);
        this.getTokenFromFCM();
      },
      error => {
        this.checkAuth(error.extras || {}, customlogin);
      }
    );
  };

  logoutHandler = () => {
    postJSON(
      BASE_URL + LOGOUT,
      {},
      response => {},
      error => console.log((error.extras || {}).message)
    );
    this.resetApp();
  };

  resetApp = () => {
    // localStorage.clear();
    this.props.history.replace(WELCOME_PAGE_URL);
    this.props.resetApp();
    this.setState({ loading: false });
  };

  componentWillReceiveProps(nextProps) {
    const { firebaseDetails, orderID, location } = nextProps;
    const {
      askNotificationPermission = false,
      notificationPopupShown = false
    } = firebaseDetails;
    if (orderID.length !== 0) {
      this.setState({ showSuccessCard: true });
    } else {
      this.setState({ showSuccessCard: false });
    }
    if (askNotificationPermission && !notificationPopupShown) {
      this.checkToAskNotification();
      this.props.clearNotificationPermission();
    }

    if (location !== this.props.location) {
      window.scrollTo(0, 0);
      if (this.props.location) {
        localStorage.setItem("previousRoute", this.props.location.pathname);
      }
    }
  }

  componentWillUnmount() {
    this.unregister();
  }

  fetchFoodCourtDetails = (loading = false, route = false) => {
    this.setState({ loading });
    const foodCourtId =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    this.setState({ loading: true });
    postJSON(
      BASE_URL + GET_FOOD_COURT_SETTINGS,
      { foodcourtid: foodCourtId.value },
      response => {
        const settings = response.extras.details;
        this.props.storeFoodCourtSettings(settings);
        this.setState({ loading: false });
        if (route) {
          this.props.history.push("/auth", {
            isVerified: false,
            source: "app"
          });
        }
      },
      error => {
        this.setState({ loading: false });
        this.props.setAlertPopup(
          (error.extras || {}).message || GENERAL_ERROR_MSG
        );
      }
    );
  };

  redirect = () => {
    const { loggedIn, userVerified } = this.state;
    if (loggedIn) {
      let currentFoodCourt =
        JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
      if (userVerified) {
        if (!currentFoodCourt) {
          this.logoutHandler();
        } else {
          this.fetchFoodCourtDetails();
          let { pathname } = this.props.location;
          if (this.shouldRedirect(pathname)) {
            this.props.history.replace(DASHBOARD_PAGE_URL);
          }
          this.setState({ loading: false });
        }
      } else {
        let loading = true,
          route = true;
        this.fetchFoodCourtDetails(loading, route);
      }
    } else {
      this.props.history.replace(WELCOME_PAGE_URL);
      this.setState({ loading: false });
    }
  };

  shouldRedirect = pathname => {
    // if index.html is there it was not redirecting anywhere
    // thats why added "index.html"
    const nonLoginedInPaths = [
      WELCOME_PAGE_URL,
      "/welcome",
      AUTH_PAGE_URL,
      "/index.html"
    ];

    return nonLoginedInPaths.includes(pathname);
  };

  getSucessModalTimeoutFromFirebase = () => {
    const dbRef = firebase.database();
    const status = dbRef.ref().child("web/foodbook/successModalTimeout");
    status.on("value", snapshot => {
      this.setState({ successModaltimeout: snapshot.val() || 30000 });
    });
  };

  render() {
    const {
      userVerified,
      loading,
      showSuccessCard,
      notificationDetails,
      askNotificationConfirmation,
      showFoodcourtListing,
      hideAlertBtn,
      customlogin
    } = this.state;
    const {
      title,
      description,
      positiveButtonLabel,
      negativeButtonLabel
    } = NOTIFICATION_PERMISSION;
    const { orderID } = this.props;

    let isOpenSuccessModal = ((orderID || {}).orderids || []).length > 0;

    return (
      // <div>
      <ErrorBoundary>
        {!loading ? (
          <Switch>
            <Route
              path={AUTH_PAGE_URL}
              render={() => <SignupSignin userVerified={userVerified} />}
            />
            <Route
              path={DASHBOARD_PAGE_URL + "/:page?"}
              render={() => (
                <Dashboard
                  logoutHandler={this.logoutHandler}
                  showFoodcourtListing={showFoodcourtListing}
                  closeFoodcourtListing={this.closeFoodcourtListing}
                />
              )}
            />
            {/* <Route path={DASHBOARD_PAGE_URL} component={Dashboard} /> */}
            {/* remove the checkout after dev/testing */}
            <Route path={CHECKOUT_PAGE_URL} component={Checkout} />
            <Route path={CAFE_PASS_URL} component={CafePass} />
            <Route
              path={RESTAURANT_PAGE_URL + "/:name"}
              component={Restaurant}
            />
            <Route path={SETTING_PAGE_URL} component={Settings} />
            <Route component={Home} />
          </Switch>
        ) : (
          <Loading />
        )}
        <Snackbar />
        <AlertPopup hideAlertBtn={hideAlertBtn} />
        <AutoUpdate />
        {/* <TCDialog logoutHandler={this.logoutHandler} /> */}
        {!customlogin && <AddToHomeScreenWrapper />}
        {isOpenSuccessModal && (
          <OrderSuccessModal
            orderID={orderID}
            successModaltimeout={this.state.successModaltimeout}
          />
        )}
        {notificationDetails.show && (
          <NotificationHandler
            details={notificationDetails}
            handleClose={this.closeNotitificationDialog}
          />
        )}

        {!customlogin && (
          <ConfirmBox
            open={askNotificationConfirmation}
            title={title}
            description={description}
            positiveText={positiveButtonLabel}
            positiveButton={this.getPushNotificationPermission}
            negativeText={negativeButtonLabel}
            negativeButton={this.cancelPopupHandler}
          />
        )}
      </ErrorBoundary>

      // </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    orderID: state.successOrderID,
    firebaseDetails: state.firebaseDetails,
    isPreOrder: Object.keys(state.preorderData || {}).length > 0,
    currentFoodCourtDetails: state.currentFoodCourtDetails || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    storeUserDetails: details => {
      dispatch(storeUserDetails(details));
    },
    clearUserDetails: () => {
      dispatch(clearUserDetails());
    },
    resetApp: () => {
      dispatch({ type: "PURGE_EVERYTHING" });
    },
    setFirebaseStaticData: data => {
      dispatch(setFirebaseStaticData(data));
    },
    clearNotificationPermission: () => {
      dispatch(clearNotificationPermission());
    },
    setFoodCourt: location => {
      dispatch(setFoodCourt(location));
    },
    storeFoodCourtSettings: details => {
      dispatch(storeFoodCourtSettings(details));
    },
    setAlertPopup: alertMessage => {
      dispatch(setErrorMessage(alertMessage));
    },
    setSessionsData: sessionsDetails =>
      dispatch(setSessionsData(sessionsDetails))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js